/**
 * Instância única do mapa OpenLayers — CONTRATO COMPARTILHADO.
 *
 * O módulo app-core cria o mapa e chama `setMap`. Os demais módulos
 * (focos, vetores, exportação) obtêm o mapa com `useMapInstance(s => s.map)`
 * e adicionam/removem as próprias camadas.
 */
import { create } from 'zustand';
import type OlMap from 'ol/Map';

interface MapInstanceState {
  map: OlMap | null;
  setMap: (map: OlMap | null) => void;
}

export const useMapInstance = create<MapInstanceState>()((set) => ({
  map: null,
  setMap: (map) => set({ map }),
}));
